import React, { useState } from 'react'
import './css/Main.css'
import './css/newBanner.css'
import Modal from 'react-modal'
import b1 from './image/hero.png'
import s3 from './image/s3.png'
import s4 from './image/s4.png'
import s5 from './image/s5.png'
import s6 from './image/s6.png'
import b11 from './image/b12.jpg'
import b12 from './image/b13.jpg'
import b13 from './image/b14.jpg'
import { Form } from './Form.js'
import { Card2 } from './Card2'

Modal.setAppElement('#root')

const services = [
  {
    icon: '🤖',
    name: 'Agentic AI',
    desc: 'Autonomous AI agents that plan, reason, and execute complex multi-step tasks with minimal human intervention.',
    isNew: true,
  },
  {
    icon: '🧠',
    name: 'LLM Private Training & RAG',
    desc: 'Fine-tune LLMs on your proprietary data and build RAG pipelines for real-time, accurate enterprise AI responses.',
    isNew: true,
  },
  {
    icon: '👁️',
    name: 'Computer Vision',
    desc: 'Real-time object detection, image classification, and visual automation powered by deep learning.',
    isNew: false,
  },
  {
    icon: '⚙️',
    name: 'Embedded Systems',
    desc: 'Hardware-level AI integration for IoT, edge computing, and real-time embedded applications.',
    isNew: false,
  },
  {
    icon: '📡',
    name: 'IVR Systems',
    desc: 'AI-powered Interactive Voice Response systems for seamless, intelligent customer interactions.',
    isNew: false,
  },
  {
    icon: '📊',
    name: 'Web Analytics & Digital Marketing',
    desc: 'Data-driven marketing strategies and analytics pipelines that deliver measurable business growth.',
    isNew: false,
  },
]

export const Main = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalIsOpen2, setModalIsOpen2] = useState(false)

  return (
    <>
      {/* ── HERO ── */}
      <section className="hero-section">
        <div className="hero-inner">
          <div>
            <span className="hero-badge">AI Research &amp; Innovation</span>
            <h1 className="hero-title">
              Building the{' '}
              <span className="hero-highlight">Intelligence</span>
              <br />
              of Tomorrow
            </h1>
            <p className="hero-subtitle">
              Empowering businesses with Agentic AI, private LLM training,
              RAG pipelines, Computer Vision, and Embedded Systems — end to end.
            </p>
            <div className="hero-actions">
              <a href="#services" className="btn-primary">
                Explore Services
              </a>
              <a href="#contact" className="btn-ghost">
                Get in Touch
              </a>
            </div>
          </div>
          <div className="hero-image-wrap">
            <img src={b1} alt="AI Research" />
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="stats-section">
        <div className="stats-grid">
          <div>
            <div className="stat-number">50+</div>
            <div className="stat-label">Projects Delivered</div>
          </div>
          <div>
            <div className="stat-number">8+</div>
            <div className="stat-label">AI Services</div>
          </div>
          <div>
            <div className="stat-number">100%</div>
            <div className="stat-label">Private &amp; Secure</div>
          </div>
          <div>
            <div className="stat-number">24/7</div>
            <div className="stat-label">Expert Support</div>
          </div>
        </div>
      </section>

      {/* ── SERVICES GRID ── */}
      <section id="services" className="services-section">
        <div className="section-header">
          <span className="section-eyebrow">What We Do</span>
          <h2 className="section-title">End-to-End AI &amp; Technology Services</h2>
          <p className="section-subtitle">
            From cutting-edge AI to embedded systems, we deliver full-stack
            technology solutions tailored to your enterprise.
          </p>
        </div>
        <div className="services-grid">
          {services.map((s, i) => (
            <div key={i} className={`service-card${s.isNew ? ' featured' : ''}`}>
              <div className="service-icon">{s.icon}</div>
              <h3 className="service-name">
                {s.name}
                {s.isNew && <span className="new-tag">New</span>}
              </h3>
              <p className="service-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── FEATURE: AGENTIC AI ── */}
      <section className="feature-section dark-bg">
        <div className="feature-inner">
          <div className="feature-text on-dark">
            <span className="eyebrow">Featured Service</span>
            <h2>Agentic AI Solutions</h2>
            <p>
              Deploy autonomous AI agents that plan, reason, and execute
              complex workflows with minimal human oversight. From automating
              business operations to intelligent decision-making pipelines,
              our Agentic AI systems act with purpose.
            </p>
            <ul className="feature-checklist on-dark">
              <li>Multi-step task planning and execution</li>
              <li>Tool-use and API integration</li>
              <li>Memory and context management</li>
              <li>Human-in-the-loop checkpoints</li>
            </ul>
            <button
              className="btn-outline-light"
              onClick={() => setModalIsOpen(true)}
            >
              Get Started →
            </button>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={() => setModalIsOpen(false)}
              style={{
                overlay: { backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1000 },
                content: {
                  maxWidth: '560px',
                  margin: 'auto',
                  borderRadius: '20px',
                  padding: '40px',
                  inset: '40px auto auto',
                },
              }}
            >
              <Form />
              <button className="modal-close" onClick={() => setModalIsOpen(false)}>
                Close
              </button>
            </Modal>
          </div>
          <div className="feature-img-wrap on-dark">
            <img src={s6} alt="Agentic AI" />
          </div>
        </div>
      </section>

      {/* ── FEATURE: LLM & RAG ── */}
      <section className="feature-section light-bg">
        <div className="feature-inner reverse">
          <div className="feature-img-wrap">
            <img src={s5} alt="LLM and RAG" />
          </div>
          <div className="feature-text on-light">
            <span className="eyebrow">Featured Service</span>
            <h2>Private LLM Training &amp; RAG</h2>
            <p>
              Fine-tune large language models on your proprietary data —
              fully private, compliant, and domain-specific. Combine with
              Retrieval-Augmented Generation (RAG) pipelines to deliver
              real-time, factual answers from your own knowledge base.
            </p>
            <ul className="feature-checklist on-light">
              <li>Private model fine-tuning on your data</li>
              <li>Secure on-premise or cloud deployment</li>
              <li>RAG pipeline with vector search</li>
              <li>Zero data leakage, no hallucinations</li>
            </ul>
            <button className="btn-primary" onClick={() => setModalIsOpen2(true)}>
              How It Works →
            </button>
            <Modal
              isOpen={modalIsOpen2}
              onRequestClose={() => setModalIsOpen2(false)}
              style={{
                overlay: { backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 1000 },
                content: {
                  background: '#000',
                  border: 'none',
                  borderRadius: '20px',
                  padding: '0',
                  maxWidth: '700px',
                  margin: 'auto',
                  inset: '40px auto auto',
                },
              }}
            >
              <div style={{ padding: '40px' }}>
                <Card2 />
              </div>
              <div style={{ padding: '0 40px 40px' }}>
                <button className="modal-close" onClick={() => setModalIsOpen2(false)}>
                  Close
                </button>
              </div>
            </Modal>
          </div>
        </div>
      </section>

      {/* ── FEATURE: COMPUTER VISION ── */}
      <section className="feature-section dark-bg">
        <div className="feature-inner">
          <div className="feature-text on-dark">
            <span className="eyebrow">Core Capability</span>
            <h2>Computer Vision</h2>
            <p>
              From real-time object detection and facial recognition to quality
              inspection and scene understanding — we build robust vision
              pipelines that turn images and video into actionable intelligence.
            </p>
            <ul className="feature-checklist on-dark">
              <li>Object detection &amp; tracking</li>
              <li>Image classification &amp; segmentation</li>
              <li>Anomaly detection for quality control</li>
              <li>Real-time video analytics</li>
            </ul>
          </div>
          <div className="feature-img-wrap on-dark">
            <img src={s4} alt="Computer Vision" />
          </div>
        </div>
      </section>

      {/* ── GALLERY CAROUSEL ── */}
      <section style={{ padding: '80px 5%', background: '#f8fafc' }}>
        <div className="section-header" style={{ marginBottom: '36px' }}>
          <span className="section-eyebrow">Our Work</span>
          <h2 className="section-title">In the Field</h2>
          <p className="section-subtitle">A glimpse of our real-world deployments and research projects</p>
        </div>
        <div style={{ maxWidth: '960px', margin: '0 auto' }}>
          <div className="carousel">
            <div className="carousel-inner">
              <input className="carousel-open" type="radio" id="carousel-1" name="carousel" aria-hidden="true" hidden defaultChecked />
              <div className="carousel-item"><img src={b11} alt="project 1" /></div>
              <input className="carousel-open" type="radio" id="carousel-2" name="carousel" aria-hidden="true" hidden />
              <div className="carousel-item"><img src={b12} alt="project 2" /></div>
              <input className="carousel-open" type="radio" id="carousel-3" name="carousel" aria-hidden="true" hidden />
              <div className="carousel-item"><img src={b13} alt="project 3" /></div>
              <label htmlFor="carousel-3" className="carousel-control prev control-1">‹</label>
              <label htmlFor="carousel-2" className="carousel-control next control-1">›</label>
              <label htmlFor="carousel-1" className="carousel-control prev control-2">‹</label>
              <label htmlFor="carousel-3" className="carousel-control next control-2">›</label>
              <label htmlFor="carousel-2" className="carousel-control prev control-3">‹</label>
              <label htmlFor="carousel-1" className="carousel-control next control-3">›</label>
              <ol className="carousel-indicators">
                <li><label htmlFor="carousel-1" className="carousel-bullet">•</label></li>
                <li><label htmlFor="carousel-2" className="carousel-bullet">•</label></li>
                <li><label htmlFor="carousel-3" className="carousel-bullet">•</label></li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* ── HOW WE WORK ── */}
      <section className="process-section">
        <div className="section-header">
          <span
            className="section-eyebrow"
            style={{ background: 'rgba(99,102,241,0.2)', color: '#a5b4fc', border: '1px solid rgba(99,102,241,0.4)' }}
          >
            Our Process
          </span>
          <h2 className="section-title" style={{ color: '#f1f5f9' }}>
            How We Work
          </h2>
          <p className="section-subtitle" style={{ color: '#64748b' }}>
            A proven, structured approach from discovery to deployment
          </p>
        </div>
        <div className="process-grid">
          <div className="process-step">
            <div className="process-number">1</div>
            <h4>Discovery</h4>
            <p>We understand your business goals, data landscape, and technical requirements.</p>
          </div>
          <div className="process-step">
            <div className="process-number">2</div>
            <h4>Design</h4>
            <p>Our architects design a tailored AI solution — model, pipeline, and infrastructure.</p>
          </div>
          <div className="process-step">
            <div className="process-number">3</div>
            <h4>Build &amp; Train</h4>
            <p>We train, fine-tune, and test models on your private data with rigorous evaluation.</p>
          </div>
          <div className="process-step">
            <div className="process-number">4</div>
            <h4>Deploy &amp; Scale</h4>
            <p>Seamless deployment to your environment with ongoing monitoring and support.</p>
          </div>
        </div>
      </section>

      {/* ── IVR & SMS ── */}
      <section className="feature-section light-bg">
        <div className="feature-inner">
          <div className="feature-img-wrap">
            <img src={s3} alt="IVR Systems" />
          </div>
          <div className="feature-text on-light">
            <span className="eyebrow">Communication AI</span>
            <h2>IVR &amp; SMS Integration</h2>
            <p>
              Build intelligent voice and messaging systems that handle customer
              interactions automatically. Our AI-powered IVR reduces wait times,
              improves resolution rates, and delivers 24/7 availability without
              scaling headcount.
            </p>
            <ul className="feature-checklist on-light">
              <li>AI-powered speech recognition &amp; NLU</li>
              <li>Automated call routing &amp; resolution</li>
              <li>SMS automation and 2-way messaging</li>
              <li>CRM and ticketing system integration</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section id="contact" className="cta-section">
        <h2>Ready to Build with AI?</h2>
        <p>
          Let's talk about how Iria Research can accelerate your AI transformation —
          from strategy to production.
        </p>
        <button className="btn-white" onClick={() => setModalIsOpen(true)}>
          Start a Conversation
        </button>
      </section>
    </>
  )
}
